import { PREFIX, URIType } from "../uri";

export class PatientBlobURI {
  type: URIType.PatientBlob = URIType.PatientBlob;
  patientId: string;
  path: string;

  static parse(uri: string) {
    const parts = uri.split(":").map(decodeURIComponent);
    if (parts[1] === "patient" && parts[3] === "blob") {
      const [, , patientId, , path] = parts;
      return new PatientBlobURI(patientId, path);
    }

    return null;
  }

  static fromString(text: string) {
    const uri = PatientBlobURI.parse(text);
    if (!uri) {
      throw new Error("Not PatientBlobURI");
    }
    return uri;
  }

  constructor(patientId: string, path: string) {
    this.patientId = patientId;
    this.path = path;
  }

  toString() {
    return [PREFIX, "patient", this.patientId, "blob", this.path]
      .map(encodeURIComponent)
      .join(":");
  }
}

export class RecordingBlobURI {
  type: URIType.RecordingBlob = URIType.RecordingBlob;
  deviceId: string;
  recordingId: string;
  path: string;

  static parse(uri: string) {
    const parts = uri.split(":").map(decodeURIComponent);
    if (parts[1] === "recording" && parts[4] === "blob") {
      const [, , deviceId, recordingId, , path] = parts;
      return new RecordingBlobURI(deviceId, recordingId, path);
    }

    return null;
  }

  static fromString(text: string) {
    const uri = RecordingBlobURI.parse(text);
    if (!uri) {
      throw new Error("Not RecordingBlobURI");
    }
    return uri;
  }

  constructor(deviceId: string, recordingId: string, path: string) {
    this.deviceId = deviceId;
    this.recordingId = recordingId;
    this.path = path;
  }

  toString() {
    return [
      PREFIX,
      "recording",
      this.deviceId,
      this.recordingId,
      "blob",
      this.path,
    ]
      .map(encodeURIComponent)
      .join(":");
  }
}
